import { Div } from "../../../../../base/components/native/div"
import { Img } from "../../../../../base/components/native/img"
import { replaceDigits } from "../../../../../base/helpers/locales"
import services from "../../../../../services"
import { simpleInput } from "../../shared/simple-input"
import { submitButton } from "../../shared/submit-button"
import { Tab } from "../tab"
import { bannerGroupStyle, inputsStyle } from "./banners.style"


export const BannersTab = () => {
    const base = Tab('banners')

    /* DEAL BANNER */
    const dealBanner = Div()
    dealBanner.cssClass(bannerGroupStyle)

    const dealBannerInputs = Div()
    dealBannerInputs.cssClass(inputsStyle)
    dealBanner.append(dealBannerInputs)

    const dealBannerHeader = simpleInput('هدر بنر')
    const dealbannerTitle = simpleInput('عنوان ویژه')
    const dealBannerValue = simpleInput('مقدار ویژه')
    dealBannerValue.style({ textAlign: 'right' })
    const dealBannerSubmit = submitButton('به روز رسانی اطلاعات بنر').style({ position: 'relative' })
    dealBannerSubmit.el.disabled = true
    dealBannerInputs.append(dealBannerHeader, dealbannerTitle, dealBannerSubmit)

    const dealImage = Img('/api/image/live/deal', { width: 300 })
    dealBanner.cssClass({ cursor: 'pointer' })
    dealImage.el.onclick = () => window.open('/api/image/live/deal', '_blank')
    dealBanner.append(dealImage)

    /* USDT BANNER */
    const usdtBanner = Div()
    usdtBanner.cssClass(bannerGroupStyle)

    const usdtBannerInputs = Div()
    usdtBannerInputs.cssClass(inputsStyle)
    usdtBanner.append(usdtBannerInputs)

    const usdtBannerHeader = simpleInput('هدر بنر')
    const usdtBannerSubmit = submitButton('به روز رسانی اطلاعات بنر').style({ position: 'relative' })
    usdtBannerSubmit.el.disabled = true
    usdtBannerInputs.append(usdtBannerHeader, usdtBannerSubmit)

    const usdtImage = Img('/api/image/live/usdt', { width: 300 })
    usdtImage.cssClass({ cursor: 'pointer' })
    usdtImage.el.onclick = () => window.open('/api/image/live/usdt', '_blank')
    usdtBanner.append(usdtImage)


    /* CAD BANNER */
    const cadBanner = Div()
    cadBanner.cssClass(bannerGroupStyle)

    const cadBannerInputs = Div()
    cadBannerInputs.cssClass(inputsStyle)
    cadBanner.append(cadBannerInputs)

    const cadBannerHeader = simpleInput('هدر بنر')
    const cadBannerSubmit = submitButton('به روز رسانی اطلاعات بنر').style({ position: 'relative' })
    cadBannerSubmit.el.disabled = true
    cadBannerInputs.append(cadBannerHeader, cadBannerSubmit)

    const cadImage = Img('/api/image/live/cad', { width: 300 })
    cadImage.cssClass({ cursor: 'pointer' })
    cadImage.el.onclick = () => window.open('/api/image/live/cad', '_blank')
    cadBanner.append(cadImage)

    /* Zelle BANNER */
    const zelleBanner = Div()
    zelleBanner.cssClass(bannerGroupStyle)

    const zelleBannerInputs = Div('')
    zelleBannerInputs.style({ width: '95%', flexShrink: '0' })
    zelleBanner.append(zelleBannerInputs)

    const zelleImage = Img('/api/image/live/zelle', { width: 300 })
    zelleImage.cssClass({ cursor: 'pointer' })
    zelleImage.el.onclick = () => window.open('/api/image/live/zelle', '_blank')
    zelleBanner.append(zelleImage)

    // reload the images after submit   
    dealBannerSubmit.el.addEventListener('click', async () => {
        if (!dealbannerTitle.getValue() || !dealBannerValue.getValue()) return
        dealBannerSubmit.disable()
        dealBannerSubmit.el.innerText = 'در حال به روز رسانی...'
        const converted = replaceDigits(dealBannerValue.getValue())
        await services.rates.updateDeal({ title: dealbannerTitle.getValue(), value: converted, _id: '6782b9a6e80d774be18e47fc' })
        await services.rates.updateMessage('DEAL_MESSAGE', dealBannerHeader.getValue())
        dealBannerSubmit.el.innerText = 'اطلاعات بنر به روز شد'
        setTimeout(() => {
            dealBannerSubmit.el.innerText = 'به روز رسانی اطلاعات بنر'
            dealBannerSubmit.enable()
        }, 1000);
        dealImage.el.src = '/api/image/live/deal?' + new Date().getTime()
    })

    usdtBannerSubmit.el.addEventListener('click', async () => {
        if (!usdtBannerHeader.getValue()) return
        usdtBannerSubmit.disable()
        usdtBannerSubmit.el.innerText = 'در حال به روز رسانی...'
        await services.rates.updateMessage('USDT_MESSAGE', usdtBannerHeader.getValue())
        usdtBannerSubmit.el.innerText = 'اطلاعات بنر به روز شد'
        setTimeout(() => {
            usdtBannerSubmit.el.innerText = 'به روز رسانی اطلاعات بنر'
            usdtBannerSubmit.enable()
        }, 1000);
        usdtImage.el.src = '/api/image/live/usdt?' + new Date().getTime()
    })

    cadBannerSubmit.el.addEventListener('click', async () => {
        if (!cadBannerHeader.getValue()) return
        cadBannerSubmit.disable()
        cadBannerSubmit.el.innerText = 'در حال به روز رسانی...'
        await services.rates.updateMessage('CAD_MESSAGE', cadBannerHeader.getValue())
        cadBannerSubmit.el.innerText = 'اطلاعات بنر به روز شد'
        setTimeout(() => {
            cadBannerSubmit.el.innerText = 'به روز رسانی اطلاعات بنر'
            cadBannerSubmit.enable()
            cadImage.el.src = '/api/image/live/cad?' + new Date().getTime()
        }, 1000);
    })


    services.rates.getMessages().then(messages => {
        const dealMessage = messages.find(({ key }: any) => key === 'DEAL_MESSAGE')
        const usdtMessage = messages.find(({ key }: any) => key === 'USDT_MESSAGE')
        const cadMessage = messages.find(({ key }: any) => key === 'CAD_MESSAGE')

        dealBannerHeader.setValue(dealMessage?.value)
        usdtBannerHeader.setValue(usdtMessage?.value)
        cadBannerHeader.setValue(cadMessage?.value)

        services.rates.getDeals().then(deals => {
            /* 
            {
                "_id": "6782b9a6e80d774be18e47fc",
                "title": "چهارشنبه ۱۵ ژانویه|26 دی",
                "value": "56800",
                "at": "2025-01-15T18:19:31.661Z"
            }
            */
            const deal = deals[0]
            dealbannerTitle.setValue(deal.title)
            dealBannerValue.setValue(deal.value)

            dealBannerSubmit.enable()
            usdtBannerSubmit.enable()
            cadBannerSubmit.enable()

        })

        // [
        //     {
        //         "_id": "635ab1efc2855e6dc80d5d1c",
        //         "key": "USDT_MESSAGE",
        //         "value": "خرید ایمیل ترنسفر و ارسال فوری به ایران",
        //         "at": "2025-01-11T13:57:08.730Z"
        //     },
        //     {
        //         "_id": "635ab210c2855e6dc80d5d1d",
        //         "key": "CAD_MESSAGE",
        //         "value": "خرید ایمیل ترنسفر و ارسال فوری به ایران",
        //         "at": "2025-01-11T13:57:10.479Z"
        //     },
        //     {
        //         "_id": "6782bd7be8a2bb684a231c0a",
        //         "key": "DEAL_MESSAGE",
        //         "value": "فروش ویژه نقدی و چک با رسید صرافی",
        //         "at": "2025-01-13T22:41:58.811Z"
        //     }
        // ]
    })


    base.append(dealBanner, usdtBanner, cadBanner, zelleBanner)

    return base
}